import { useCallback } from 'react'
import Project from 'common/project'
import _data from 'common/utils/_data'
import { BookingPayload, BookingPayloadDocumentReview } from 'common/types/MemberBooking'

const isDocumentReviewPayload = (payload: BookingPayload): payload is BookingPayloadDocumentReview =>
  'document_to_review' in payload || 'document_to_review_url' in payload

function getEndpoint(payload: BookingPayload) {
  return isDocumentReviewPayload(payload)
    ? `${Project.liveApi}book-a-lawyer/document-review-request/`
    : `${Project.liveApi}book-a-lawyer/appointments/`
}

function buildBody(payload: BookingPayload) {
  // If it’s a document review payload containing a file, build FormData
  if (isDocumentReviewPayload(payload) && payload.document_to_review) {
    const formData = new FormData()
    formData.append('document_to_review', payload.document_to_review)
    Object.entries(payload).forEach(([key, value]) => {
      if (key !== 'document_to_review') {
        formData.append(key, value as string)
      }
    })
    return formData
  }
  // Otherwise just return JSON
  return payload
}

export const usePostBooking = () => {
  const postBooking = useCallback(async (payload: BookingPayload) => {
    try {
      const endpoint = getEndpoint(payload)
      const body = buildBody(payload)
      const headers = { AUTHORIZATION: `Bearer ${_data.token}` }

      const result = await fetch(endpoint, {
        method: 'POST',
        body: body instanceof FormData ? body : JSON.stringify(body),
        headers: { ...headers },
      })

      if (!result.ok) {
        const errorText = await result.text()
        console.error('Error response:', errorText)
        throw new Error(`Failed to save booking request: ${errorText}`)
      }

      return result
    } catch (error) {
      console.error('Failed to save booking request', error)
      throw error
    }
  }, [])

  return { postBooking }
}
